module.exports = __webpack_public_path__ + "img/indexBg.19038927.jpg";